'use strict';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import {getAsLink} from '../../core-utilities/domain/ReduxUtils';
import {
  assignAssetProjectToModel,
  assignAssetToModel,
  assignOrganizationToModel,
  assignProjectToModel,
  assignUserToModel,
  hydrateModel,
} from './actions';
import {getAsset, getAssetProject, getOrganization, getOrgProfile, getProject, getUser} from './reducers/state';


// TODO: remove when all imports from this module have been migrated
export * from '../../core-utilities/domain/ReduxUtils';

// Lazy injection
let $domain = null;
let $translate = null;

// AngularDomain -> Redux transition helper methods

/**
 *
 * @param {String} message - The i18n message code
 * @param {String} labelProp - The state property to set the message to
 * @param {Object} [params]
 */
export function translate(message, labelProp, params) {
  if (!$translate) {
    // eslint-disable-next-line max-len
    return Promise.reject(new Error('AppModel has not been initialized properly. If this is a test, you must mock AppModel and $domain.'));
  } else {
    return Observable
      .fromPromise($translate(message, params))
      .map(value => ({[labelProp]: value}));
  }
}

export function $modelProvider() {
  return {
    $get: [
      '$ngRedux',
      '$domainCache',
      '$domain',
      '$translate',
      function (...args) {
        return new AppModel(...args);
      }],
    $$constructor: AppModel,
  };
}

// TODO: subclass for the admin console's needs and replace the current model with this system in the admin console.
function AppModel(
  $ngRedux,
  $domainCache,
  _$domain,
  _$translate,
) {
  $domain = _$domain;
  $translate = _$translate;

  this.serialize = () => ({
    organization: getAsLink(getOrganization($ngRedux.getState())),
    project: getAsLink(getProject($ngRedux.getState())),
    asset: getAsLink(getAsset($ngRedux.getState())),
    assetProject: getAsLink(getAssetProject($ngRedux.getState())),
  });

  this.hydrate = (model) => {
    const deferred = Promise.defer();
    const action = hydrateModel($ngRedux.getState().model, model, deferred);
    if (action === null) {
      deferred.resolve();
    } else {
      $ngRedux.dispatch(action);
    }
    return deferred.promise;
  };

  Object.defineProperties(this, {
    keyChain: {
      writable: true,
      value: null,
    },
    user: {
      get: () => getUser($ngRedux.getState()),
      set: (nv) => $ngRedux.dispatch(assignUserToModel(nv)),
    },
    userPreferences: {
      get: () => void 0,
    },
    organization: {
      get: () => getOrganization($ngRedux.getState()),
      set: (nv) => $ngRedux.dispatch(assignOrganizationToModel(nv)),
    },
    orgProfile: {
      get: () => getOrgProfile($ngRedux.getState()),
    },
    project: {
      get: () => getProject($ngRedux.getState()),
      set: (nv) => $ngRedux.dispatch(assignProjectToModel(nv)),
    },
    asset: {
      get: () => getAsset($ngRedux.getState()),
      set: (nv) => $ngRedux.dispatch(assignAssetToModel(nv)),
    },
    assetProject: {
      get: () => getAssetProject($ngRedux.getState()),
      set: (nv) => $ngRedux.dispatch(assignAssetProjectToModel(nv)),
    },
  });
}



// WEBPACK FOOTER //
// ./src/js/app/model/AppModel.js